<template>
  <!--
  @TODO: Add Managers to App.vue
  Keypress manager
  Boxie manaager
  Tooltip manager
  Toaster manager
  Notification manager

  Video manager?
  Bestand manager?
  -->
  <teleport to="body">
    <p
      v-if="showNewUpdate"
      class="fixed top-0 left-0 right-0 w-full overflow-hidden text-center bg-green-400 font-bold text-white text-sm py-1"
    >
      Nouvelle version de l'application disponible.
      <button aria-label="refresh page" @click="refresh" class="text-blue-600 underline">Metre a jour</button>
    </p>
  </teleport>
  <transition-group name="page-fade">
    <ScreenView v-if="percentageReady < 100" :value="percentageReady"> Chargement </ScreenView>
    <div v-else>
      <Empty v-show="showOfflineBanner" class="overflow-hidden px-4 text-center">
        <p class="font-bold text-red-500 text-lg pt-8">Vous êtes hors ligne, connectez-vous à Internet !</p>
        <p>Une fois en ligne, nous vous montrerons à nouveau la page sur laquelle vous étiez actif.</p>
        <p>Vous ne devez donc pas recharger la page.</p>
      </Empty>
      <component v-show="!showOfflineBanner" :is="LayoutComponent">
        <main>
          <router-view />
        </main>
      </component>
    </div>
  </transition-group>
</template>

<script>
import { computed, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import Layouts from './layouts'
import ScreenView from '@/components/Templates/Overlays/OverlayLoading'
import useStoreReady from '@/hooks/useStoreReady'
import cacheBust from '@/hooks/useCacheBust'

export default {
  components: {
    ScreenView,
    ...Layouts,
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    // const router = useRouter()
    const LayoutComponent = computed(() => {
      const layoutName = (route.meta && route.meta.layout) || 'Default'
      return Layouts[layoutName] || Layouts.Empty
    })
    const { percentageReady } = useStoreReady(store)

    const isOnline = ref(true)
    const showOfflineBanner = computed(() => !isOnline.value && !route.meta.enableOffline)
    const showNewUpdate = computed(() => !!store.state.app.newContent)

    if (typeof navigator !== 'undefined') {
      navigator.serviceWorker?.addEventListener('controllerchange', () => {
        window.location.reload(true)
      })
    }

    function updateOnlineStatus() {
      if (typeof navigator === 'undefined') return
      isOnline.value = !!(navigator.onLine || navigator.online)
    }
    onMounted(() => {
      window.addEventListener('online', updateOnlineStatus)
      window.addEventListener('offline', updateOnlineStatus)
      updateOnlineStatus()
    })

    watch(
      () => percentageReady.value,
      val => {
        if (val < 100) return
        if (!store.getters.isAuthenticated && route.path !== '/login') {
          window.location = '/login'
        } else if (route.query.refresh) {
          window.location = window.location.pathname
        }
      },
    )

    return {
      refresh: () =>
        cacheBust(() => {
          window.location = '?refresh=true'
        }),
      LayoutComponent,
      percentageReady,
      // route,
      state: store.state,
      showOfflineBanner,
      showNewUpdate,
    }
  },
}
</script>
